import { render, staticRenderFns } from "./falseAlarm.vue?vue&type=template&id=00c5a4b4&"
import script from "./falseAlarm.vue?vue&type=script&lang=js&"
export * from "./falseAlarm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports